import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";

export class paySelectedDialogCtrl implements IController {

  commissionIds: any;
  commissionPrice: any;
  accountId: any;

  private request: any;
  private paymentMethods: any;
  private working: any;

  /* @ngInject */
  constructor(private $mdDialog, private $payment, private commonsAlertsService: CommonsAlertsService, private splitService) {
  }

  $onInit() {
    this.request = {
      agentAccountId: this.accountId,
      commissionPrice: this.commissionPrice,
      currencyCode: this.splitService.getCurrencyCode(),
      commissionIds: this.commissionIds,
      paymentMethod: "Check",
      totalPrice: this.commissionPrice,
      extraPrice: 0
    };
    this.paymentMethods = [
      {
        title: 'Cash',
        value: 'Cash'
      },
      {
        title: 'Check',
        value: 'Check'
      },
      {
        title: 'Credit Card',
        value: 'CreditCard'
      }];
  }

  onExtraPriceChange(extraPrice) {
    this.request.totalPrice = this.commissionPrice;
    this.request.totalPrice += extraPrice ? extraPrice : 0;
  }

  close() {
    this.$mdDialog.cancel();
  };

  onUploadDoc(result) {
    this.request.invoiceUrl = _.get(result, 'data.url');
    this.working = false;
  };

  onStartUpload() {
    this.working = true;
  };

  submit() {
    this.working = true;
    this.$payment().$put(this.request)
      .then(() => {return this.$mdDialog.hide})
      .then(() => {
        this.working = false;
        this.commonsAlertsService.paySelectedSuccess();
        this.$mdDialog.hide();
      });
  };

}

angular
  .module('bringoz.admin.commissions')
  .component('paySelectedDialog', {
    bindings: {
      commissionIds: '<',
      commissionPrice: '<',
      accountId: '<'
    },
    template: require('./pay-selected-dialog.html').default,
    controller: paySelectedDialogCtrl
  });
